import React from "react";
import { areasItems } from "../../json/areas";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import "./detalleareas.css";

const DetalleAreas = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { enlace } = useParams();
  const area = areasItems.find((area) => area.enlace === enlace);

  return (
    <div className="areas-container">
      <div className="row">
        <div className="col_12">
          <div className="areas_title">
            <h1>{area.nombre}</h1>
          </div>
        </div>
      </div>
      <div className="row">
        {area.DireccionGeneral.map((general, index) => {
          return (
            <div key={index} className="col-12 custom-no-padding">
              <div className="rubro_container_detalle">
                <div className="detalle_rubro_nombre">
                  <div class="banner">
                    <h1 className="titulo-area"> {general.nombreGeneral} </h1>
                    <img src={general.imagenGeneral} alt="Imagen 1" />
                    <img src={general.imagenGeneral2} alt="Imagen 2" />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DetalleAreas;
